import { LinkReportRoutes, reduced } from "@podtrac/common/links";
import { Route, Routes } from "react-router-dom";
import { api } from "./links-api";
import { LinksIndex } from "./links-index";
import { LinksSettings } from "./links-settings";
import { LinksLayout } from "./links-layout";
import { LinksReportLayout } from "./links-report-layout";

export function LinksRoutes() {
    return (
        <Routes>
            <Route path="*" element={<LinksLayout />}>
                <Route index element={<LinksIndex />} />
                <Route path="settings/:promotionID" element={<LinksSettings />} />
                <Route path="reports/*" element={<LinksReportLayout />}>
                    <Route
                        path="*"
                        element={
                            <LinkReportRoutes
                                index="placements"
                                api={api}
                                config={reduced}
                            />
                        }
                    />
                </Route>
            </Route>
        </Routes>
    );
}
